import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";

// contexts
import SettingsProvider from "./contexts/SettingsContext";
import { store } from "./components/store";
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocketProvider } from "./contexts/SocketContext";

import SystemHealthProvider from "./contexts/SystemHealthContext";

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <SocketProvider>
        <SettingsProvider>
          <SystemHealthProvider>
            <BrowserRouter basename={process.env.REACT_APP_BASENAME || ""}>
              <App />
              <ToastContainer />
            </BrowserRouter>
          </SystemHealthProvider>
        </SettingsProvider>
      </SocketProvider>
    </ReduxProvider>
  </HelmetProvider>
);

reportWebVitals();
